var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 8,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.255 11.9975L19.755 11.2475C19.4775 11.1125 19.1325 11.2175 18.9975 11.495C18.855 11.78 18.9675 12.1175 19.245 12.2525L20.4375 12.845V16.4375L17.625 16.445V8.75C17.625 7.25 16.62 6.5 15.375 6.5H9.375C8.13 6.5 7.125 7.25 7.125 8.75V20.9375H6C5.6925 20.9375 5.4375 21.1925 5.4375 21.5C5.4375 21.8075 5.6925 22.0625 6 22.0625H18.75C19.0575 22.0625 19.3125 21.8075 19.3125 21.5C19.3125 21.1925 19.0575 20.9375 18.75 20.9375H17.625V17.57L21 17.5625C21.315 17.5625 21.5625 17.3075 21.5625 17V12.5C21.5625 12.29 21.4425 12.095 21.255 11.9975ZM9 10.1675C9 9.125 9.6375 8.75 10.4175 8.75H14.34C15.1125 8.75 15.75 9.125 15.75 10.1675V11.09C15.75 12.125 15.1125 12.5 14.3325 12.5H10.4175C9.6375 12.5 9 12.125 9 11.0825V10.1675ZM9.375 14.1875H11.625C11.9325 14.1875 12.1875 14.4425 12.1875 14.75C12.1875 15.0575 11.9325 15.3125 11.625 15.3125H9.375C9.0675 15.3125 8.8125 15.0575 8.8125 14.75C8.8125 14.4425 9.0675 14.1875 9.375 14.1875Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDevice);
export default __webpack_public_path__ + "static/media/total-device.4c82abd8b4ca16dd0d09fa3b5fbd2982.svg";
export { ForwardRef as ReactComponent };